export default __webpack_public_path__ + "static/media/settings-black.65dabf6b.svg";